import PayslipData from "pages/MyZone/Payslip/PayslipData";
import BulkPayslipData from "../PayProcessing/PayrollCycleRun/CostStructure/BulkPdfFileData";
import WageSlipData, { BulkWageSlipData } from "./WageSlipTemplate";
import FormXixWageSlipData, {
  BulkFormXixWageSlipData,
} from "./FormXixWageSlipTemplate";
import DetailedPayslipData, {
  BulkDetailedPayslipData,
} from "./DetailedPayslipTemplate";
import InnoPayslipData, { BulkInnoPayslipData } from "./InnoPayslipTemplate";

export const PAYSLIP_TEMPLATES = [
  {
    id: "standard",
    name: "Standard Payslip",
    description:
      "Employee pay summary with earnings, deductions and net pay.",
    SingleDocument: PayslipData,
    BulkDocument: BulkPayslipData,
  },
  {
    id: "wageslip",
    name: "Wage Slip",
    description:
      "Statutory wage slip format (Under Rule 27(2) Of the minimum wages Chennai rules 1953).",
    SingleDocument: WageSlipData,
    BulkDocument: BulkWageSlipData,
  },
  {
    id: "formxixwageslip",
    name: "Wage Slip (Form XIX)",
    description:
      "Statutory Form XIX wage slip with earnings, deductions, attendance and OT details.",
    SingleDocument: FormXixWageSlipData,
    BulkDocument: BulkFormXixWageSlipData,
  },
  {
    id: "detailedpayslip",
    name: "Detailed Payslip",
    description:
      "Colour pay statement with employee and payroll information, earnings, deductions, attendance and overtime summaries.",
    SingleDocument: DetailedPayslipData,
    BulkDocument: BulkDetailedPayslipData,
  },
  {
    id: "innopayslip",
    name: "Payslip (Inno format)",
    description:
      "Inno Machining pay statement with fixed and earning salary columns, deductions, attendance and leave balances.",
    SingleDocument: InnoPayslipData,
    BulkDocument: BulkInnoPayslipData,
  },
];

export const getTemplateById = (id) =>
  PAYSLIP_TEMPLATES.find((template) => template.id === id) ||
  PAYSLIP_TEMPLATES[0];

export const SAMPLE_PAYSLIP_DATA = {
  user_name: "Lavanya M.",
  employee_id: "EMP1001",
  user_designation: "Machine Operator",
  department_name: "Production",
  date_of_service: "01-04-2024",
  parents_name: "Sample Guardian",
  pf_no: "100946338900",
  esi_no: "0",
  uan_no: "101234567890",
  holidays: 0,
  pay_schedule_name: "FEBRUARY-2026",
  start_date: "01-02-2026",
  end_date: "28-02-2026",
  pay_date: "28-02-2026",
  pay_period: "February-2026",
  company_name: "Cauver",
  company_address: "27 Old Gloucester Street, London, United Kingdom, WC1N 3AX",
  monthly_salary: 22550,
  total_payable_shift: 28,
  net_payable_shift: 26,
  lop_days: 2,
  gross_salary: 29728.06,
  net_salary: 25921.06,
  net_pay: 25921.06,
  net_pay_in_words: "Twenty Five Thousand Nine Hundred Twenty One Only",
  earnings: [
    { component_name: "Basic", amount: 10470 },
    { component_name: "DA", amount: 4188 },
    { component_name: "HRA", amount: 6282 },
    { component_name: "Leave Salary", amount: 805 },
    { component_name: "Nightshift Allow.", amount: null },
    { component_name: "Sunday Allow.", amount: null },
    { component_name: "OT", amount: null },
    { component_name: "Attendance Bonus", amount: 0 },
    { component_name: "Mobile Charges", amount: 0 },
  ],
  total_earnings: 21745,
  deduction: [
    { component_name: "PF", amount: 1759 },
    { component_name: "ESI", amount: null },
    { component_name: "Lunch", amount: 40 },
    { component_name: "Salary Advance", amount: 1500 },
    { component_name: "PT", amount: 208 },
    { component_name: "LWF", amount: null },
  ],
  total_deductions: 3507,
  other_earnings: [
    {
      component_name: "2 OT Weekoff Attendance",
      name: "2 OT Weekoff Attendance",
      category: "Other Earnings",
      method: "Hours",
      quantity: "16:00",
      per_day: 68.55,
      amount: 1096.77,
    },
    {
      component_name: "1.5 OT Overtime",
      name: "1.5 OT Overtime",
      category: "Other Earnings",
      method: "Hours",
      quantity: "99:00",
      per_day: 68.55,
      amount: 6786.29,
    },
    {
      component_name: "Overtime Earnings",
      name: "Overtime Earnings",
      category: "Other Earnings",
      method: "Fixed",
      quantity: "0",
      per_day: 0,
      amount: 100,
    },
  ],
  total_other_earnings: 7983.06,
  other_deduction: [
    { component_name: "Loan Recovery", name: "Loan Recovery", amount: 300 },
  ],
  total_other_deductions: 300,
  net_earnings_by_band: {
    "1.5 OT": {
      earning: "66:00",
      earning_minutes: 3960,
      band_factor: 1.5,
      adjusted_quantity: "66:00",
      total_deducted: "- 80:00",
      total_deducted_minutes: 4800,
      net_earnings: "00:00",
      net_earnings_minutes: 0,
    },
    "2 OT": {
      earning: "08:00",
      earning_minutes: 480,
      band_factor: 2.0,
      adjusted_quantity: "08:00",
      total_deducted: "—",
      total_deducted_minutes: 0,
      net_earnings: "08:00",
      net_earnings_minutes: 480,
    },
  },
};
